import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
export const WaitForPageSettle = ({ loadingPlaceholder, timeout = 6000, children })=>{
    const [isPageSettled, setIsPageSettled] = useState(false);
    useEffect(()=>{
        // Check if page is already loaded
        if (document.readyState === 'complete') {
            // Use requestIdleCallback to wait for browser to be idle
            if ('requestIdleCallback' in window) {
                requestIdleCallback(()=>{
                    setIsPageSettled(true);
                }, {
                    timeout
                });
            } else {
                // Fallback for browsers that don't support requestIdleCallback
                setTimeout(()=>{
                    setIsPageSettled(true);
                }, timeout);
            }
            return ()=>{};
        }
        // Wait for load event
        const handleLoad = ()=>{
            if ('requestIdleCallback' in window) {
                requestIdleCallback(()=>{
                    setIsPageSettled(true);
                }, {
                    timeout
                });
            } else {
                setTimeout(()=>{
                    setIsPageSettled(true);
                }, timeout);
            }
        };
        window.addEventListener('load', handleLoad);
        // Cleanup listener on unmount
        return ()=>{
            window.removeEventListener('load', handleLoad);
        };
    }, [
        timeout
    ]);
    // Show loading placeholder if it exists and page is not settled
    if (!isPageSettled && loadingPlaceholder !== null && loadingPlaceholder !== undefined) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: loadingPlaceholder
        });
    }
    // Don't render children until page is settled
    if (!isPageSettled) {
        return null;
    }
    // Render children after page settles
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
